import React from "react";
import { Outlet } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { SidebarMenu } from "./SidebarMenu";

export const Sidebar: React.FC = () => {
  const sidebarHandler = (flag: boolean) => {
    var sideBar: any = document.getElementById("mobile-nav")!;
    var openSidebar = document.getElementById("openSideBar")!;
    var closeSidebar = document.getElementById("closeSideBar")!;
    sideBar.style.transform = "translateX(-260px)"!;

    if (flag) {
      sideBar.style.transform = "translateX(0px)";
      openSidebar.classList.add("hidden");
      closeSidebar.classList.remove("hidden");
    } else {
      sideBar.style.transform = "translateX(-260px)";
      closeSidebar.classList.add("hidden");
      openSidebar.classList.remove("hidden");
    }
  };

  return (
    <>
      <div className="w-full h-full">
        <div className="flex flex-no-wrap">
          <div
            style={{ minHeight: "100vh" }}
            className="w-64 absolute sm:relative shadow md:h-full flex-col justify-between hidden sm:flex"
          >
            <div className="bg-blue-400 h-screen">
              <SidebarMenu />
            </div>
          </div>
          <div
            className="w-64 z-40 absolute bg-white shadow md:h-full flex-col justify-between sm:hidden transition duration-150 ease-in-out"
            id="mobile-nav"
          >
            <button
              aria-label="toggle sidebar"
              id="openSideBar"
              className="h-10 w-10 bg-white absolute right-0   -mr-10 flex items-center shadow rounded-tr rounded-br justify-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 rounded focus:ring-gray-800"
              onClick={() => sidebarHandler(true)}
            >
              <Bars3Icon className="h-5 w-5 text-gray-800" />
            </button>
            <button
              aria-label="Close sidebar"
              id="closeSideBar"
              className="hidden h-10 w-10 bg-white absolute right-0 -mr-10 items-center shadow rounded-tr rounded-br justify-center cursor-pointer text-gray-800"
              onClick={() => sidebarHandler(false)}
            >
              <XMarkIcon className="h-5 w-5 text-gray-800" />
            </button>
            <SidebarMenu />
          </div>
          <div className="container mx-auto md:w-4/5 w-11/12 px-6">
            <div
              className="w-full h-full"
              style={{ maxHeight: "100vh", overflowY: "scroll" }}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
